import React from 'react';

const ContactContent = ({ contact, setContact, handleContactSubmit, contactStatus }) => {
  return (
    <form onSubmit={handleContactSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', color: 'var(--text-color, #ffffff)' }}>
     
      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--text-color, #ffffff)' }}>Name</label>
        <input
          type="text"
          value={contact.name}
          onChange={(e) => setContact({ ...contact, name: e.target.value })}
          required
          style={{ 
            width: '100%', 
            padding: '0.75rem', 
            borderRadius: '6px', 
            border: '1px solid var(--input-border, #444)', 
            backgroundColor: 'var(--input-background, #2d2d2d)',
            color: 'var(--text-color, #ffffff)',
            boxSizing: 'border-box' 
          }}
        />
      </div>
      
      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--text-color, #ffffff)' }}>Email</label>
        <input
          type="email"
          value={contact.email}
          onChange={(e) => setContact({ ...contact, email: e.target.value })}
          required
          style={{ 
            width: '100%', 
            padding: '0.75rem', 
            borderRadius: '6px', 
            border: '1px solid var(--input-border, #444)', 
            backgroundColor: 'var(--input-background, #2d2d2d)',
            color: 'var(--text-color, #ffffff)',
            boxSizing: 'border-box' 
          }}
        />
      </div>
      
      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--text-color, #ffffff)' }}>Message</label>
        <textarea
          value={contact.message}
          onChange={(e) => setContact({ ...contact, message: e.target.value })}
          required
          rows={5}
          style={{ 
            width: '100%', 
            padding: '0.75rem', 
            borderRadius: '6px', 
            border: '1px solid var(--input-border, #444)', 
            backgroundColor: 'var(--input-background, #2d2d2d)',
            color: 'var(--text-color, #ffffff)',
            boxSizing: 'border-box', 
            resize: 'vertical' 
          }}
        />
      </div>
      
      <button
        type="submit"
        disabled={contactStatus === 'submitting'}
        style={{
          padding: '0.75rem',
          backgroundColor: 'var(--primary-color, #4285F4)',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: contactStatus === 'submitting' ? 'not-allowed' : 'pointer',
          fontWeight: 'bold',
          marginTop: '0.5rem',
          fontSize: '1rem',
          transition: 'background-color 0.2s',
          opacity: contactStatus === 'submitting' ? 0.7 : 1
        }}
      >
        {contactStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      
      {contactStatus === 'success' && (
        <div style={{ color: '#4caf50', marginTop: '0.5rem', textAlign: 'center', fontWeight: '500' }}>
          Message sent successfully!
        </div>
      )}
      
      {contactStatus === 'error' && (
        <div style={{ color: '#f44336', marginTop: '0.5rem', textAlign: 'center', fontWeight: '500' }}>
          Failed to send message. Please try again.
        </div>
      )}
    </form>
  );
};

export default ContactContent;
